import React from 'react';
/*
import {
  ht,
  cr,
  a,
  f,
  BoxC,
  LgnMailC,
  MsgC,
  RootC,
  GridC,
  TextC,
  useGblz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as MsgC from "./_cccMsgC";
import * as LgnMailC from "./_ccmLgnMailC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import FtrC from './IccvFtr';

export const N = (pz: {
  sPz: ht.dz,
}) => {
  
  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`sc/lt1`),
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            lineCs: [
              {
                cellCs: [
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgOrnz',
                        textz: {
                          pfx: '全体共通　施設予約管理',
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn1Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '▼',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '登録したメールアドレスを入力し、[送る] ボタンを押してください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: 'ログイン用「確認コード」が記されたメールが、このアドレス宛に届きますので、ご確認ください。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LgnMailC.S, {
                        key: -10,
                        sPz: pz.sPz,
                        cz: {
                          ccd: `rd7`,
                          grtCfmz: (_dz: ht.dz) => ({
                            cdn: `_10rt1100i = 90` 
                          }),
                        }
                      })
                    ]
                  }
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [

                      cr.c(BoxC.N, {
                        key: -10,
                        boxStlz: a('f/1'),
                        oClds: [

                          cr.c(MsgC.N, {
                            key: -10,
                            abtType: 'lgn2Cmnz',
                            cz: {
                              ls: [
                                {
                                  mkrCz: {
                                    textz: {
                                      pfx: '※',
                                    }
                                  },
                                  msgCz: {
                                    textz: {
                                      pfx: '指定したメールアドレス宛に確認コードが送信されない場合は、使用しているメールアプリや通信キャリアの受信設定もご確認ください。',
                                    },
                                  }
                                },
                                {
                                  mkrCz: {
                                    textz: {
                                      pfx: '※',
                                    }
                                  },
                                  msgCz: {
                                    textz: {
                                      pfx: '正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスもご確認ください。',
                                    },
                                  }
                                },

                              ]
                            }
                          }),

                          cr.c(TextC.N, {
                            key: -30,
                            textz: {
                              pfx: '※ 本システムは、最新版の Chrome, Safari, Edge, FireFox にてご利用いただけます。',
                              stlz: a('ts/s'),
                            },
                          }),

                        ]
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/2'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(FtrC, {
            key: -30,
          })
        ],
      },
    })
  );
};
